import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

const Qwen25Agent = () => {
    return (
        <Box sx={{
            backgroundColor: '#f5f5f5',
            minHeight: 'calc(100vh - 64px)', // Adjust based on your Navbar height
            pt: { xs: '80px', md: '100px' }, // Responsive padding top
            pb: 8
        }}>
            <Container maxWidth="lg">
                <Paper elevation={3} sx={{ p: { xs: 2, sm: 4 }, borderRadius: 2 }}>
                    <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ fontWeight: 600, mb: 3 }}>
                        Qwen 2.5 Agent Coder
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                        {/* Embed Agent with iframe */}
                        <iframe
                            src="https://qwen-qwen2-5-coder-artifacts.hf.space"
                            frameBorder="0" // Note: frameBorder is deprecated, consider using CSS border: 'none'
                            style={{
                                border: '1px solid #e0e0e0', // Added a light border for consistency
                                borderRadius: '8px',
                                width: '100%',      // Make width responsive
                                maxWidth: '850px',   // Keep max width
                                height: '600px',     // Adjusted height for better view
                                display: 'block'
                            }}
                            title="Qwen 2.5 Agent Coder"
                        ></iframe>
                        <Typography variant="caption" sx={{ mt: 2, color: 'text.secondary' }}>
                            Agent interactif hébergé sur Hugging Face Spaces.
                        </Typography>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default Qwen25Agent; 